import { baseURL } from './api';

export const ACCESS_TOKEN_STORAGE_KEY = 'access_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
export const TRUSTED_DEVICE_TOKEN_STORAGE_KEY = 'trusted_device_token';
export const TFA_VALIDATED_STORAGE_KEY = 'tfa_validated';
export const ADMIN_TAKEOVER_TOKEN_STORAGE_KEY = 'takeover_token';
export const SELECTED_COMPANY_ID_STORAGE_KEY = 'selected_company_id';
export const CURRENT_USER = 'current_user';
export const CURRENT_IMPERSONATED_COMPANY_UUID = 'current_company';
export const filesURL =
  process.env.REACT_APP_S3_APP_ASSETS_BUCKET ||
  'https://marco-platform-app-assets-development.s3.amazonaws.com';

export const MAX_RETRIES = 3;
export const APPLICATION_VERSION = process.env.REACT_APP_APPLICATION_VERSION || 'local';
export const PAGE_SIZE = 10;
export const CURRENT_APP_STEP_STORAGE_KEY = 'current_app_step_storage_key';
export const APP_FLOW = 'app_flow';

//Routes
export const DASHBOARD = '/dashboard';
export const ADMIN_DASHBOARD = '/admin-dashboard';
export const COMPANY_USER = '/companies/:id/*';
export const NOT_FOUND = '/*';
export const LLC = '/llc';
export const VERIFY_EMAIL_SENT = '/verifyemailsent';
export const LOGIN = '/login';
export const TWO_FACTOR_AUTHENTICATION = '/two-factor-authentication';
export const RESET_PASSWORD = '/reset-password';
export const EMAIL_VERIFICATION = '/email-verification';
export const CREATE_NEW_PASSWORD = '/create-new-password';
export const ACTIVATION = '/activation';
export const SIGNUP = '/signup';
export const CREATE_ACCOUNT_USING_EMAIL = '/create-account-using-email';
export const INVITATION_SIGNUP = '/signup-with-invitation';
export const INVOICE_FINANCING = '/invoice-financing';
export const APPLICATION = '/invoice-financing/application';
export const MY_DOCUMENTS = '/my-documents';
export const BUYER_SUMMARY = `${INVOICE_FINANCING}/buyer-summary`;
export const REPORTING = `${INVOICE_FINANCING}/reporting`;
export const AR_AGING = `${REPORTING}/ar-aging`;
export const INVOICES = `${INVOICE_FINANCING}/invoices`;
export const MY_ACCOUNT = '/my-account';
export const MY_ACCOUNT_ADMIN = '/my-account-admin';
export const LEGAL_ASSISTANT = `${baseURL}/structuringai/`;
export const CONTACT = '/contact';
export const BANKING_REPORTS = '/banking-admin';
export const BANKING_CONNECTED_ACCOUNTS = '/banking-admin/connected-accounts';
export const BANKING_CASH_CONTROL_CONNECTED_ACCOUNTS = '/cash-control/accounts';
export const BANKING_CASH_CONTROL_CONNECTED_ACCOUNT_DETAIL = '/cash-control/accounts/:id';
export const CASH_CONTROL_LENDERS = '/cash-control/lenders';
export const LENDER_DASHBOARD = '/lender/dashboard';
export const LENDER_CLIENTS = '/lender/clients';
export const LENDER_CLIENT_DETAIL = '/lender/clients/:accountId';
export const LENDER_CREATE_TRANSFER = `${LENDER_CLIENT_DETAIL}/transfers/new`;
export const LENDER_CREATE_TRANSFER_EXISTING_RECIPIENT = `${LENDER_CLIENT_DETAIL}/transfers/new/existing-recipient`;
export const LENDER_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID = `${LENDER_CREATE_TRANSFER_EXISTING_RECIPIENT}/:id`;
export const LENDER_CREATE_TRANSFER_NEW_RECIPIENT = `${LENDER_CLIENT_DETAIL}/transfers/new/new-recipient`;
export const LENDER_TRANSACTIONS = '/lender/transactions';
export const LENDER_PROFILE = '/lender/profile';
export const BANKING_CONNECTED_ACCOUNT_DETAIL = '/banking-admin/connected-accounts/:id';
export const BANKING_RECENT_TRANSACTIONS = '/banking-admin/recent-transactions';
export const BANKING_ADMIN_CARDS = '/banking-admin/cards';
export const BANKING_ADMIN_RFIS = '/banking-admin/rfis';
export const BANKING_LOW_ACTIVITY_ACCOUNTS = '/banking-admin/low-activity-accounts';
export const PAYMENTS = `${INVOICE_FINANCING}/payments`;
export const PAYMENT_DETAILS = `${PAYMENTS}/:id`;
export const TRACKING = '/tracking';
export const TRACK_INVOICE = '/track-invoice';
export const TRACK_INVOICE_ROUTE = `${TRACK_INVOICE}/:uuid`;
export const POST_CC = `/credit-committee`;
export const POST_CC_DETAIL = `/credit-committee/:id`;
export const BANKING = '/banking';
export const BANKING_ACCOUNT_DETAIL = '/banking/:currency';
export const BANKING_TRANSACTIONS = '/banking/transactions';
export const BANKING_TRANSFERS = '/banking/transfers';
export const BANKING_CREATE_TRANSFER = '/banking/transfers/new';
export const BANKING_CREATE_TRANSFER_EXISTING_RECIPIENT = '/banking/transfers/new/existing-recipient';
export const BANKING_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID = `${BANKING_CREATE_TRANSFER_EXISTING_RECIPIENT}/:id`;
export const BANKING_CREATE_TRANSFER_NEW_RECIPIENT = '/banking/transfers/new/new-recipient';
export const BANKING_CREATE_BATCH_TRANSFER = '/banking/transfers/new/batch';
export const BANKING_CREATE_WALLET_TRANSFER = '/banking/transfers/new?type=walletToWallet';
export const BANKING_CREATE_WALLET_RECIPIENT = '/banking/transfers/new/wallet-to-wallet/new-recipient';
export const BANKING_RECIPIENTS = '/banking/recipients';
export const BANKING_ADD_RECIPIENTS = '/banking/recipients/new';
export const BANKING_EDIT_RECIPIENTS = '/banking/recipients/edit/:id';
export const BANKING_CONVERSIONS = '/banking/conversions';
export const BANKING_NEW_CONVERSION = '/banking/conversions/new';
export const BANKING_CARDS = '/banking/cards';
export const BANKING_REPORTING = '/banking/reporting';
export const BANKING_NEW_COMPANY_CARD = '/banking/cards/company/new';
export const BANKING_NEW_EMPLOYEE_CARD = '/banking/cards/employee/new';
export const BANKING_UPDATE_CARD = '/banking/cards/update/:id';
export const BANKING_CARDS_SETTINGS = '/banking/cards/settings';
export const BANKING_GLOBAL_ACCOUNTS = '/banking/global-accounts';
export const BANKING_CREATE_GLOBAL_ACCOUNT = '/banking/global-accounts/new';
export const BANKING_RECURRING_PAYMENTS = '/banking/recurring-payments';
export const BANKING_CREATE_RECURRING_PAYMENT = '/banking/recurring-payments/new';
export const BANKING_EDIT_RECURRING_PAYMENT = '/banking/recurring-payments/:id/edit';
export const BANKING_KYC_ONBOARDING = '/banking/kyc-onboarding';
export const BANKING_RFI = '/banking/rfi/:id';
export const BANKING_RFIS = '/banking/rfis';
export const LOGS = '/logs';
export const FEEDBACK = '/feedback';
export const FEEDBACK_DETAIL = '/feedback/:id';
export const TRANSFERS = `${INVOICE_FINANCING}/transfers`;
export const TRANSFER_DETAILS = `${TRANSFERS}/:id`;
export const FINANCE_REQUEST = `${INVOICE_FINANCING}/finance-request`;
export const FINANCE_REQUEST_DETAIL = `${INVOICE_FINANCING}/finance-request/:id`;
export const COMPLETED_FINANCE_REQUEST_DETAIL = `${INVOICE_FINANCING}/finance-request/completed/:id`;
export const BULK_FINANCE_REQUEST = `${INVOICE_FINANCING}/bulk-finance-request`;
export const COMPLIANCE = '/compliance';
export const ADMIN_COMPLIANCE = '/admin-compliance';
export const ADMIN_REGISTERED_AGENT = '/admin-registered-agent';
export const ADMIN_PARTNERS = '/admin-partners';
export const REGISTERED_AGENT_CONFIRM = '/registered-agent/confirm';
export const DOCUMENTS = '/documents';
export const REVOLVING_CREDIT_LINE = '/revolving-credit-line';
export const REVOLVING_CREDIT_LINE_PAYMENT = '/banking/revolving-credit-line-client/payment';
export const REVOLVING_CREDIT_LINE_ADMIN = '/revolving-credit-line-admin';
export const INVOICING = '/invoicing';
export const INVOICING_CLIENTS = `${INVOICING}/clients`;
export const INVOICING_PRODUCTS = `${INVOICING}/products`;
export const INVOICING_LIST_INVOICES = `${INVOICING}/invoices`;
export const INVOICING_NEW_INVOICE = `${INVOICING}/newInvoice`;
export const FACTORING_CREDIT_LINE = '/factoring-credit-line';
export const FACTORING_CREDIT_LINE_INVOICES = `${FACTORING_CREDIT_LINE}/invoices`;
export const FACTORING_CREDIT_LINE_SELL = `${FACTORING_CREDIT_LINE}/sell`;
export const INVOICING_EDIT_INVOICE = `${INVOICING_NEW_INVOICE}/:invoiceId`;
export const INVOICING_VIEW_INVOICE = `${INVOICING_LIST_INVOICES}/:invoiceId`;
export const INVOICE_PUBLIC_VIEWER_ROUTE = '/i/:token';

export function path(
  pathTemplate: string,
  params: { [key: string]: string | number },
  query?: { [key: string]: string }
): string {
  let url = pathTemplate;

  // Replace each placeholder in the template with the actual value from params
  for (const key in params) {
    // @ts-ignore
    url = url.replace(`:${key}`, params[key]);
  }

  // Add query parameters to the URL using URLSearchParams
  if (query) {
    const searchParams = new URLSearchParams();
    for (const key in query) {
      searchParams.append(key, query[key]);
    }
    url = `${url}?${searchParams.toString()}`;
  }

  return url;
}
